import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'shabic-icon-edit',
  templateUrl: './icon-edit.component.html',
  styleUrls: ['./icon-edit.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconEditComponent {}
